import { useEffect } from "react";

import EbayUnlistedTable from "../../components/ebayListings/unlistedTable/EbayUnlistedTable";
import { UnlistedTableStats } from "../../components/ebayListings/unlistedTable/Stats/UnlistedTableStats";
import { usePageNameContext } from "../../contexts/PageTitleContext";

export default function EbayUnlisted() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "eBay Unlisted Items",
      desc: "View and manage parts that aren't listed on eBay",
    });
  }, []);

  return (
    <div className="flex flex-col gap-y-4 mt-4">
      <UnlistedTableStats />
      <EbayUnlistedTable />
    </div>
  )
}
